import KnownTranslatorKeys from '../localization/knownTranslatorKeys'
import { enumToList } from '../utils/converters'

enum CommonGroupingOption {
  NONE = 'None',
  STATUS = 'Status',
  LBS = 'LBS',
  EQUIPMENT = 'Equipment',
  COMPANY = 'Company',
  DATE = 'Date',
  DATE_TIME = 'DateTime',
  RESPONSIBLE = 'Responsible',
}

enum FormsSpecificGroupingOption {
  CATEGORY = 'Category',
  TYPE = 'Type',
  PROJECT = 'Project',
  FILE_TYPE = 'FileType',
}

type LogisticsGroupingOption =
  | CommonGroupingOption
  | FormsSpecificGroupingOption

const LogisticsGroupingOption = {
  ...CommonGroupingOption,
  ...FormsSpecificGroupingOption,
}

const FormsGroupingOption = {
  [CommonGroupingOption.NONE]: CommonGroupingOption.NONE,
  [FormsSpecificGroupingOption.CATEGORY]: FormsSpecificGroupingOption.CATEGORY,
  [FormsSpecificGroupingOption.TYPE]: FormsSpecificGroupingOption.TYPE,
  [CommonGroupingOption.STATUS]: CommonGroupingOption.STATUS,
  [CommonGroupingOption.LBS]: CommonGroupingOption.LBS,
  [CommonGroupingOption.EQUIPMENT]: CommonGroupingOption.EQUIPMENT,
  [CommonGroupingOption.COMPANY]: CommonGroupingOption.COMPANY,
  [CommonGroupingOption.RESPONSIBLE]: CommonGroupingOption.RESPONSIBLE,
  [CommonGroupingOption.DATE]: CommonGroupingOption.DATE,
  [CommonGroupingOption.DATE_TIME]: CommonGroupingOption.DATE_TIME,
  [FormsSpecificGroupingOption.FILE_TYPE]:
    FormsSpecificGroupingOption.FILE_TYPE,
  [FormsSpecificGroupingOption.PROJECT]: FormsSpecificGroupingOption.PROJECT,
}

export const formsGroupingOptionList = enumToList(FormsGroupingOption)

export const getLogisticsGroupingOptionTranslatorKey = (
  id: string,
): KnownTranslatorKeys => {
  switch (id) {
    case CommonGroupingOption.NONE:
      return KnownTranslatorKeys.none
    case CommonGroupingOption.STATUS:
      return KnownTranslatorKeys.workflowStatus
    case CommonGroupingOption.LBS:
      return KnownTranslatorKeys.location
    case CommonGroupingOption.DATE:
      return KnownTranslatorKeys.date
    case CommonGroupingOption.COMPANY:
      return KnownTranslatorKeys.company
    case CommonGroupingOption.RESPONSIBLE:
      return KnownTranslatorKeys.responsibleUser
    case FormsSpecificGroupingOption.TYPE:
      return KnownTranslatorKeys.workflowType
    case CommonGroupingOption.EQUIPMENT:
      return KnownTranslatorKeys.equipment
    case FormsSpecificGroupingOption.CATEGORY:
      return KnownTranslatorKeys.workflowCategory
    case FormsSpecificGroupingOption.PROJECT:
      return KnownTranslatorKeys.project
    case FormsSpecificGroupingOption.FILE_TYPE:
      return KnownTranslatorKeys.fileType
    case CommonGroupingOption.DATE_TIME:
      return KnownTranslatorKeys.dateTime
    default:
      throw new Error(id + ' is unhandled')
  }
}

export default LogisticsGroupingOption
